import api from '../api'


export default{
    auth: async(email, password) => {
        const data = (await api.post(`user/session`,{
            email,
            password
        })).data

        return data
    }
}